import {push, replace, goBack} from 'connected-react-router';
import {DEFAULT_LABEL_HOSTS, IMAGES_BUCKET, WBR_MAX_LENGTH} from '../configs/constants';

export function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers[action.type]) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

export function forwardTo(location, needReplace = false) {
  // Resolve the store lazily to avoid a circular import
  // (reducers -> auth -> utils -> store -> reducers).
  const {store} = require('../store');
  const action = needReplace ? replace : push;
  return store.dispatch(action(location));
}

export function goHistoryBack() {
  const {store} = require('../store');
  return store.dispatch(goBack());
}

export function getThirdLevelSubdomain() {
  const {hostname} = location;
  return DEFAULT_LABEL_HOSTS.some(host => hostname.indexOf(host) !== -1) ? 'test-game' : hostname.split('.')[0];
}

export function convertTo32BitInteger(str) {
  // eslint-disable-next-line
  return str.split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
}

export function wbr(str) {
  return str
    .replace(RegExp(`(\\w{${WBR_MAX_LENGTH}})(\\w)`, 'g'), (all, text, char) => `${text}<wbr>${char}`)
    .replace(/\n/g, '<br />');
}

export const onImageError = url => ({target: img}) => {
  const failbackClassName = 'failback-img';
  img.onerror = null;
  img.onload = () => img.classList.remove(failbackClassName);
  img.classList.add(failbackClassName);

  img.src = url;
};

export const getResizeImagePaths = (imageUrl = '', width, height) => {
  if (!imageUrl) {
    return {
      defaultImageURL: null,
      resizedImageURL: null,
    };
  }

  const resizeKey = `${width}${height ? `x${height}` : ''}`;

  const defaultImageURL = imageUrl.replace(
    IMAGES_BUCKET,
    `${process.env.API_URL}/img/${resizeKey}/`
  );
  const resizedImageURL = imageUrl.replace(
    IMAGES_BUCKET,
    `${IMAGES_BUCKET}resized/${resizeKey}/`
  );

  return {
    defaultImageURL,
    resizedImageURL,
  };
};

export function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
